export type OrganizationDTO = {
  orgId: number;
  orgCode: string;
  orgName: string;
  league: string;
  domain: string;
  city: string;
};

export const ORG_IDS = {
  BOC: 31,
  USA_BASEBALL: 33,
  TOP_PROSPECT: 35,
};

export const PROFILE_TYPE_IDS = {
  DRAFT: 1,
  SHOWCASE: 2,
  MEDICAL_STUDY: 3,
};

export type OrganizationManagementDTO = {
  id: number;
  name: string;
  inviteType: number;
  isDirty: boolean;
};
